import React, { useEffect, useState } from 'react';
import Breadcrumbs from './Breadcrumbs';


const Statewise = () => {
    const  [data, setData] = useState([]);
    const getCovidData = async ()=>{
        // const res = await  fetch('https://api.covid19india.org/data.json');
        // const actualData = await res.json();
        // console.log(actualData.statewise);
        // setData(actualData.statewise);
        // // const result = await axios.get("https://api.covid19india.org/data.json");
        // // setData(result.data.statewise.reverse());


        //  //error halding
    try{
        const response = await fetch("https://api.covid19india.org/data.json");
          
              const resJson = await response.json();
               console.log(resJson);
              setData(resJson.statewise);
            
    }
    catch(error){
   console.log(error);

    }
   

    }
    useEffect(() => {
        getCovidData();
    }, []);
    return (
        <>
        <Breadcrumbs name="StateWise Covid Record Live" linename="covid"/>
        <section id="services" className="services">
      <div className="container">

        <div className="section-title">
          <h2>Live </h2>
          <h1>INDIA COVID-19 Dashboard</h1>        </div>

        <div className="row">
            
            <table  className="table table-hover" style={{fontSize:"16px"}}>
                <thead className="thead-dark">
                    <tr>
                    <th>State</th>
                    <th>Confirmed</th>
                    <th>Recovered</th>
                    <th>Deaths</th>
                    <th>Active</th>
                    <th>Updated</th>
                    </tr>
                </thead>
                <tbody>
                {
                    data.map((curElem, ind)=>{
                        return(
                            <tr>
                    <td>{curElem.state}</td>
                    <td>{curElem.confirmed}</td>
                    <td>{curElem.recovered}</td>
                    <td>{curElem.deaths}</td>
                    <td>{curElem.active}</td>
                    <td>{curElem.lastupdatedtime}</td>
                    </tr>
                        )

                    })
                }
                
                </tbody>
            </table>
            </div>
            </div>
            
            </section>
        </>
    )
}

export default Statewise;
